import {Type} from '@github-ui/react-query-persister/typebox'
import {Compile} from '@github-ui/react-query-persister/typebox/compile'

const PermissiveObject = Type.Object({}, {additionalProperties: true})

const DeferredNavPayloadSchema = Type.Object(
  {
    nav_menu: PermissiveObject,
    user_menu: PermissiveObject,
    create_menu: PermissiveObject,
    agents_menu: PermissiveObject,
    account_switch_dialog: PermissiveObject,
  },
  {additionalProperties: true},
)

export const DeferredNavPayloadValidator = Compile(DeferredNavPayloadSchema)
